export const setActiveTab = (tabIndex) => ({ type: actions.SET_ACTIVE_TAB, tabIndex });

const actions = {
    SET_ACTIVE_TAB: 'activeTab/SET_ACTIVE_TAB'
};

export default actions;
